export default __webpack_public_path__ + "static/media/linkedin.c8d6482e.svg";